<script setup lang="ts">
  import type {IPagingInfo} from '@/app/shared/helpers/paged-result.ts';
  import Paginator, {type PageState} from 'primevue/paginator';
  import {computed, type PropType} from 'vue';

  const props = defineProps({
    pagingInfo: { type: Object as PropType<IPagingInfo>, default: () => ({}) },
  });

  const emit = defineEmits({
      changePage: (pageNr: number) => true,
  });

  // backward compatible page numbers (used to be 1 based)
  const firstRow = computed((): number => {
    return (props.pagingInfo.page - 1) * props.pagingInfo.pageSize;
  });

</script>

<template>
  <Paginator
      :first="firstRow"
      :rows="pagingInfo.pageSize"
      :totalRecords="pagingInfo.totalItems"
      template="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
      currentPageReportTemplate="{first} - {last} van {totalRecords}"
      @page="(event: PageState) => emit('changePage', event.page + 1)"
  />
</template>

<style scoped lang="scss">

</style>

